import React, { createContext, useContext } from "react";

import { Router } from "@/types";

const RouterContext = createContext<Router | undefined>(undefined);

export const AppRouterProvider: React.FC<{ router: Router; children: React.ReactNode }> = ({
  router,
  children,
}) => (
  <RouterContext.Provider value={router}>
    {children}
  </RouterContext.Provider>
);

/** The current path and navigate function used by the app's navigation components */
export const useAppRouter = () => {
  const router = useContext(RouterContext);
  if (router === undefined) {
    throw new Error("useAppRouter must be used within an AppRouterProvider");
  }
  return router;
};
